import { render, staticRenderFns } from "./MaintenenceBody.vue?vue&type=template&id=3d32a008&scoped=true&"
import script from "./MaintenenceBody.vue?vue&type=script&lang=ts&"
export * from "./MaintenenceBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d32a008",
  null
  
)

export default component.exports